import React from "react";

import { Toolbox as Value } from "@reactivated";

import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

import { AlignedRichText } from "../AlignedRichTextBlock";
import { BigHeroBlock } from "../BigHero";
import { Faq } from "../Faq";
import { FullWidthMediaBlock } from "../FullWidthMedia";
import { Image3UpBlock } from "../Image3UpBlock";
import { Image3UpHoverBlock } from "../Image3UpHoverBlock";
import { ImageTextCarouselBlock } from "../ImageTextCarousel";
import { MediaPullQuoteCarouselBlock } from "../MediaPullQuoteCarousel";
import { ScrollingImageGalleryBlock } from "../ScrollingImageGalleryBlock";
import { SpacerBlock } from "../SpacerBlock";
import { Specs } from "../SpecsBlock";
import { ValuePropsBlock } from "../ValuePropsBlock";

export const toolboxComponents: StreamFieldBlockMap<Value> = {
    big_hero: BigHeroBlock,
    full_width_media: FullWidthMediaBlock,
    image_3up: Image3UpBlock,
    image_3up_hover: Image3UpHoverBlock,
    image_text_carousel: ImageTextCarouselBlock,
    media_pull_quote_carousel: MediaPullQuoteCarouselBlock,
    scrolling_image_gallery: ScrollingImageGalleryBlock,
    spacer: SpacerBlock,
    value_props: ValuePropsBlock,
    faq: Faq,
    rich_text: AlignedRichText,
    specs: Specs,
};

export const Toolbox = (props: { value: Value }) => {
    return (
        <StreamField
            tagName={React.Fragment}
            components={toolboxComponents}
            value={props.value}
        />
    );
};
